import { useSelector } from "react-redux";
import Payer from "../utility/Payer";
import { componentKey as authenticationComponentKey } from "../../web/businesslogic/authentication/AuthenticationSlice";

export function useFormatTIN() {
    const { signedInUser } = useSelector((state) => state[authenticationComponentKey])

    const formatTIN = (idType, idNumber, hideTIN = null) => {
        if (!idType && idNumber) {
            return idNumber
        }
        
        return Payer.getPayerTINByIdType(idType, idNumber, hideTIN !== null ? hideTIN : !signedInUser.IsTinUnmaskAllowed)
    };

    return { formatTIN };

}
export default useFormatTIN;